export default __webpack_public_path__ + "static/media/Hokusai_The_Wave_of_Kanagawa_50_x_100_cm.bf291c2f.jpg";